import styles from "component/breadcrumb/t2Breadcrumb.module.scss";
import Link from "next/link";
import articlesBreadcrums from "./articles-breadcrums.json";

function StaticBredcrumList() {
  const breadcrumbs = articlesBreadcrums;
  return (
    <div className={`list-group ${styles.list_group} ${styles.t2_div}`}>
      <div>
        {breadcrumbs.map((model: any) => <div key={model.label} style={{ display: "flex", padding: "calc(1 * var(--safari-root-font, 10px)) calc(1.5 * var(--safari-root-font, 10px))" }}><Link href={model.url} style={{ color: "black" }}>{model.label}</Link></div>)}
      </div>
    </div>
  );
}

export default StaticBredcrumList;
